<div class="alert-status-wrapper">
  <div class="status" [ngClass]="ResolvedStatus[resolvedStatus!]">
    {{ ResolvedStatus[resolvedStatus!] | splitByCapitalLetterPipe }}
  </div>
</div>
